import React, { useEffect, useState } from 'react';
import {
    CAlert,
    CButton,
    CInput,
    CInputCheckbox,
    CLabel,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader
} from '@coreui/react';

interface Props {
    aberto: boolean;
    rotulo: string;
    aviso: string | null;
    erro: string | null;
    revertendo: boolean;
    onFechar: () => void;
    onConfirmar: (senha: string, esvaziar: boolean) => void;
}

/**
 * Confirmação de reversão de passo.
 *
 * Reverter apaga banco, bucket e cadastro, então pede a senha mestra em vez de
 * confiar só na sessão do admin. O "esvaziar junto" é a forma explícita de
 * liberar a remoção de bucket que ainda tem arquivo dentro: sem ele a reversão
 * para e avisa.
 */
const ReverterModal = ({ aberto, rotulo, aviso, erro, revertendo, onFechar, onConfirmar }: Props) => {
    const [senha, setSenha] = useState<string>('');
    const [esvaziar, setEsvaziar] = useState<boolean>(false);

    // A senha não sobrevive ao fechamento do modal: cada reversão pede de novo.
    useEffect(() => {
        if (!aberto) {
            setSenha('');
            setEsvaziar(false);
        }
    }, [aberto]);

    const confirmar = (evento: React.FormEvent) => {
        evento.preventDefault();
        if (senha.length > 0 && !revertendo) {
            onConfirmar(senha, esvaziar);
        }
    };

    return (
        <CModal show={aberto} onClose={onFechar} centered className="infra-modal-reverter">
            <form onSubmit={confirmar}>
                <CModalHeader closeButton>
                    <strong>Reverter “{rotulo}”</strong>
                </CModalHeader>
                <CModalBody>
                    {aviso && <CAlert color="warning" className="py-2">{aviso}</CAlert>}

                    <p className="infra-reverter-texto">
                        A reversão desfaz o que este passo criou e devolve ele para
                        pendente. Os registros de execução anteriores continuam no
                        histórico.
                    </p>

                    <div className="form-group">
                        <CLabel htmlFor="senha-mestra">Senha mestra</CLabel>
                        <CInput
                            id="senha-mestra"
                            type="password"
                            value={senha}
                            autoComplete="off"
                            autoFocus
                            onChange={(evento: React.ChangeEvent<HTMLInputElement>) => setSenha(evento.target.value)}
                        />
                    </div>

                    <div className="form-check">
                        <CInputCheckbox
                            id="esvaziar-junto"
                            checked={esvaziar}
                            onChange={(evento: React.ChangeEvent<HTMLInputElement>) => setEsvaziar(evento.target.checked)}
                        />
                        <CLabel variant="checkbox" htmlFor="esvaziar-junto">
                            Esvaziar junto (apaga também o conteúdo do bucket)
                        </CLabel>
                    </div>

                    {erro && <CAlert color="danger" className="py-2 mt-3 mb-0">{erro}</CAlert>}
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" variant="outline" onClick={onFechar} disabled={revertendo}>
                        Cancelar
                    </CButton>
                    <CButton color="danger" type="submit" disabled={senha.length === 0 || revertendo}>
                        {revertendo ? 'Revertendo…' : 'Reverter'}
                    </CButton>
                </CModalFooter>
            </form>
        </CModal>
    );
};

export default ReverterModal;
